import styled from 'styled-components';
import { Spinner } from 'ui/spinner';
import { spacing } from 'ui/theme';
import { useProfileQueryContext } from '../../../contexts/demographicInsights';
import { BrandAffinityLevelsTable } from './BrandAffinityLevelsTable';
import { CustomDemographicInsightsSection } from './CustomDemographicInsightsSection';
import { DevicesTable } from './DevicesTable';
import { EmailDomainsTable } from './EmailDomainsTable';
import { LocalesTable } from './LocalesTable';

const SpinnerWrapper = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
`;

const ProfileFieldsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  column-gap: ${spacing.plusHalf};
  row-gap: ${spacing.plusHalf};
`;

export const DemographicsProfileFields = () => {
  const { isProfileLoading } = useProfileQueryContext();

  if (isProfileLoading)
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );

  return (
    <ProfileFieldsWrapper>
      <CustomDemographicInsightsSection />
      <DevicesTable />
      <EmailDomainsTable />
      <BrandAffinityLevelsTable />
      <LocalesTable />
    </ProfileFieldsWrapper>
  );
};
